import { useEffect, useRef } from 'react'
import { OCCASIONS } from '@/constants/occasions'
import { createEditorialRevealAnimation } from '@/lib/gsap/editorial-reveals'
import type { Occasion } from '@/schemas/occasion.schema'
import { useProductsByOccasion } from '@/services/products/use-products'

export interface OccasionPageModelProps {
  occasion: Occasion
}

export function useOccasionPageModel({ occasion }: OccasionPageModelProps) {
  const { data: products } = useProductsByOccasion(occasion.id)
  const gridContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (products.length === 0) {
      return
    }

    const animation = createEditorialRevealAnimation(gridContainerRef.current)
    return () => animation?.revert()
  }, [products])

  const otherOccasions = OCCASIONS.filter((item) => item.id !== occasion.id)

  return {
    occasion,
    products,
    isEmpty: products.length === 0,
    gridContainerRef,
    otherOccasions,
  }
}
